module.exports = __webpack_public_path__ + "static/media/efix_CMYK.2a2ff119.svg";